import { makeStyles } from '@griffel/react';

import type { GriffelClassNames } from '../../util/classNames';

export const useClassNames: () => GriffelClassNames<'anchor' | 'placeholder'> = makeStyles({
  anchor: {
    display: 'block',
    position: 'relative',
    width: 0,
    height: 0,
    margin: 0,
  },
  placeholder: {
    position: 'absolute',
    width: '1px',
    height: '1px',
    outline: 'none',
  },
});
